export const SIGN_UP = '/signup';
export const SIGN_IN = '/signin';
export const LANDING = '/';
export const HOME = '/home';
export const ACCOUNT = '/account';
export const PASSWORD_FORGET = '/pw-forget';
export const SIDENAV = '/sidenav';
export const NUMBERS = '/numbers';
export const RENT = '/rent';